import axiosConfig from '../utils/axiosConfigInstance';

export const getSecondaryEmails = async () => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/secondary-email`);
	return response.data;
};

export const addSecondaryEmail = async (email) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/secondary-email`, { email });
	return response.data;
};

export const removeSecondaryEmail = async (email) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/secondary-email/remove`, { email });
	return response.data;
};

export const verifySecondaryEmail = async (email) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/secondary-email/verify`, { email });
	return response.data;
};

export const secondaryEmailApis = {
	getSecondaryEmails,
	addSecondaryEmail,
	removeSecondaryEmail,
	verifySecondaryEmail,
};
